import { render } from "./registerby-doc.vue?vue&type=template&id=17908f9b&scoped=true"
import script from "./registerby-doc.vue?vue&type=script&lang=js"
export * from "./registerby-doc.vue?vue&type=script&lang=js"

import "./registerby-doc.vue?vue&type=style&index=0&id=17908f9b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17908f9b"]])

export default __exports__